import { PaymentMethodID } from 'components/Checkout2023/types'
import { arrow_circle_up, calendar, clock, close_circle, delivery, eightbox, IconGenWithLabel, moon, shield_check } from 'components/LegacyIcon'

interface BenefitsConfig {
	warrantyAmount: number
	paymentMethod: PaymentMethodID
	hasSleepElixir: boolean
	hasSleepElixirSubscription: boolean
	hasFreeTrial: boolean
	hasFreeReturns: boolean
	hasFreeShipping: boolean
}

export const getBenefits = (config: BenefitsConfig): { icon: IconGenWithLabel; description: string }[] => {
	const { warrantyAmount, paymentMethod, hasSleepElixir, hasSleepElixirSubscription, hasFreeTrial, hasFreeReturns, hasFreeShipping } = config

	if (paymentMethod === 'fragile') {
		return [
			{
				icon: calendar,
				description: "Rent for as long as you'd like",
			},
			{
				icon: close_circle,
				description: 'Cancel anytime',
			},
			{
				icon: shield_check,
				description: 'Ongoing warranty*',
			},
		]
	}

	if (hasSleepElixir) {
		return getSleepElixirBenefits(hasSleepElixirSubscription)
	}

	const warranty = {
		icon: shield_check,
		description: `${warrantyAmount}-year warranty`,
	}
	const trial = {
		icon: moon,
		description: '30-night risk-free trial',
	}

	const returns = {
		icon: eightbox,
		description: 'Free returns',
	}

	const shipping = {
		icon: delivery,
		description: 'Free shipping',
	}

	const benefits = []
	if (warrantyAmount > 0) {
		benefits.push(warranty)
	}

	if (hasFreeTrial) {
		benefits.push(trial)
	}

	if (hasFreeReturns) {
		benefits.push(returns)
	}

	if (hasFreeShipping) {
		benefits.push(shipping)
	}

	return benefits
}

export const getSleepElixirBenefits = (hasSleepElixirSubscription = false): { icon: IconGenWithLabel; description: string }[] => {
	const returns = {
		icon: clock,
		description: 'Cancel any time',
	}

	const shipping = {
		icon: delivery,
		description: 'Free shipping',
	}

	return hasSleepElixirSubscription ? [shipping, returns] : [shipping]
}
